/**
 * The review, laid out (27/10/2026 — user: "make it intuitive minimaliste and responsive"): one
 * column — the status card on top (ready, what needs the person, why Paste is off), then every
 * part of the copy folded into one row each: containers, the master config, each kind of match
 * and the notes. Mounted per country and group, so its card and folds start over on a switch.
 * For Media Devoted | Created By Ciro Autiero
 */
import { FC } from 'react';
import type { GroupCopyChoices, GroupCopyReview } from '@trafficpulse/shared';

import { ContainerRows } from './blocks/ContainerRows';
import { NotesBlock } from './blocks/NotesBlock';
import { SectionRows } from './blocks/SectionRows';
import { StatusCard } from './blocks/StatusCard';
import { withAllSections, withContainer, withSection } from './model/paste-choices';
import { useAttention } from './model/use-attention';
import { PickFolds } from './picks/PickFolds';
import { usePickKinds } from './picks/use-pick-kinds';

interface Props {
  review: GroupCopyReview;
  choices: GroupCopyChoices;
  onChoices: (next: GroupCopyChoices) => void;
}

export const ReviewContent: FC<Props> = ({ review, choices, onChoices }) => {
  const kinds = usePickKinds(review, choices, onChoices);
  const inCard = useAttention(kinds);
  return (
    <div className="flex min-w-0 flex-col gap-3">
      <StatusCard review={review} kinds={kinds} inCard={inCard} />
      <div className="min-w-0 divide-y divide-border/60 overflow-hidden rounded-xl border border-border/70 bg-card py-1">
        <ContainerRows containers={review.containers} onTake={(id, take) => onChoices(withContainer(choices, review, id, take))} />
        <SectionRows review={review} onTake={(key, take) => onChoices(withSection(choices, review, key, take))} onAll={(take) => onChoices(withAllSections(choices, take))} />
        <PickFolds kinds={kinds} inCard={inCard} />
        <NotesBlock notes={review.notes} />
      </div>
    </div>
  );
};
